var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',{attrs:{"lg":"4"}},[_c('label',[_vm._v(_vm._s(_vm.label))])]),_c('b-col',{attrs:{"lg":"8"}},[_c('b-form-select',{attrs:{"value":_vm.value,"options":_vm.comboDescuento,"disabled":_vm.disabled},on:{"input":_vm.onInput}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }